/**
 * @param {number} move_function        移動先番号
 * @param {string} move_company_id      移動先企業ID
 * @param {string} move_organization_id 移動先店舗ID
 * @param {string} move_view_date       移動先日付（年月/年月日）
 */

// 定数
const $form_navigation = $('[name="form_navigation"]');

/**
 * データ保存確認モーダルからの画面遷移
 *
 * @returns {void}
 * @author hayakawa 2023.10.18
 */
export const movePagefromModal = () => {
    switch (Number(move_function)) {
        // マスター
        case 1: window.location.href = `${MENU_MASTER}`; break;
        // 設定
        case 2: window.location.href = `${MENU_SETTING}`; break;
        // 予測
        case 3: window.location.href = `${MENU_PREDICT}`; break;
        // シフト
        case 4: window.location.href = `${MENU_SHIFT}`; break;
        // 日計表
        case 5: window.location.href = `${MENU_EXPENSES}`; break;
        // 労務管理表
        case 6: window.location.href = `${MENU_WORK}`; break;
        // ログアウト
        case 7: document.getElementById('logout-form').submit(); break;
        // 企業
        case 101: window.location.href = `${MASTER_MENU_COMPANY}`; break;
        // 店舗
        case 102: window.location.href = `${MASTER_MENU_ORGANIZATION}`; break;
        // 従業員
        case 103: window.location.href = `${MASTER_MENU_EMPLOYEE}`; break;
        // 戻る（企業）
        case 111: window.location.href = `${RETURN_COMPANY_LIST}`; break;
        // 戻る（店舗）
        case 112: window.location.href = `${RETURN_ORGANIZATION_LIST}`; break;
        // 戻る（従業員）
        case 113: window.location.href = `${RETURN_EMPLOYEE_LIST}`; break;
        // 出勤時間
        case 201: window.location.href = `${SETTING_MENU_DEFAULT}`; break;
        // その他
        case 202: window.location.href = `${SETTING_MENU_OTHERS}`; break;
        // メッセージ
        case 203: window.location.href = `${SETTING_MENU_MESSAGE}`; break;
        // 設定（企業変更）
        case 211:
            move_company_id = (move_company_id === '') ? $('[name="move_company_id"]').val() : move_company_id;
            $form_navigation.find('[name="company_id"]').val(move_company_id)
            $form_navigation.find('[name="organization_id"]').val('');
            $form_navigation.trigger('submit');
            break;
        // 設定（店舗変更）
        case 212:
            move_organization_id = (move_organization_id === '') ? $('[name="move_organization_id"]').val() : move_organization_id;
            $form_navigation.find('[name="organization_id"]').val(move_organization_id);
            $form_navigation.trigger('submit');
            break;
        // 予測
        case 301: window.location.href = `${MENU_PREDICT}`; break;
        // 予測（企業変更）
        case 311:
            move_company_id = (move_company_id === '') ? $('[name="move_company_id"]').val() : move_company_id;
            $form_navigation.find('[name="company_id"]').val(move_company_id);
            $form_navigation.find('[name="organization_id"]').val('');
            $form_navigation.trigger('submit');
            break;
        // 予測（店舗変更）
        case 312:
            move_organization_id = (move_organization_id === '') ? $('[name="move_organization_id"]').val() : move_organization_id;
            $form_navigation.find('[name="organization_id"]').val(move_organization_id);
            $form_navigation.trigger('submit');
            break;
        // 予測（年月変更）
        case 313:
            move_view_date = (move_view_date === '') ? $('[name="move_view_date"]').val() : move_view_date;
            $form_navigation.find('[name="date_ym"]').val(move_view_date);
            $form_navigation.trigger('submit');
            break;
        // 月次
        case 401: window.location.href = `${SHIFT_MENU_MONTHLY}`; break;
        // 週次
        case 402: window.location.href = `${SHIFT_MENU_WEEKLY}`; break;
        // 日次
        case 403: window.location.href = `${SHIFT_MENU_DAYLY}`; break;
        // ヘルプ
        case 404: window.location.href = `${SHIFT_MENU_HELP}`; break;
        // ジョブ
        case 405: window.location.href = `${SHIFT_MENU_JOB}`; break;
        // 日次（企業変更）
        case 411:
            move_company_id = (move_company_id === '') ? $('[name="move_company_id"]').val() : move_company_id;
            $form_navigation.find('[name="company_id"]').val(move_view_company_id);
            $form_navigation.find('[name="organization_id"]').val('');
            $form_navigation.trigger('submit');
            break;
        // 日次（店舗変更）
        case 412:
            move_organization_id = (move_organization_id === '') ? $('[name="move_organization_id"]').val() : move_organization_id;
            $form_navigation.find('[name="organization_id"]').val(move_organization_id);
            $form_navigation.trigger('submit');
            break;
        // 日次（年月日変更）
        case 413:
            move_view_date = (move_view_date === '') ? $('[name="move_view_date"]').val() : move_view_date;
            $form_navigation.find('[name="view_date"]').val(move_view_date);
            $form_navigation.trigger('submit');
            break;
        // 日次（表示対象変更）
        case 414:
            move_display_type = (move_display_type === '') ? $('[name="move_display_type"]').val() : move_display_type;
            $form_navigation.find('[name="display_type"]').val(move_display_type);
            $form_navigation.trigger('submit');
            break;
        // 日計表
        case 501: window.location.href = `${MENU_EXPENSES}`; break;
        // 労務管理表
        case 601: window.location.href = `${MENU_WORK}`; break;
    }
};
